module.exports = __webpack_public_path__ + "images/b614c1704505ae3d8e3081485b80dff3-illu_sign.png";